import { useEffect } from "react";
import { useParams } from "wouter";
import { client } from "@/api-client";
import { FancyLoader } from "@/components/FancyLoader";
import { OwnerRoutes, UniversalRoutes, useNavigator } from "@/routers/routes";

export const TrainerInvite = () => {
  const { inviteCode } = useParams<{ inviteCode: string }>();
  const { navigate } = useNavigator();

  const {
    data: trainer,
    isLoading,
    error,
  } = client.useQuery("get", "/public/join/trainers/{inviteCode}", {
    params: {
      path: {
        inviteCode,
        trainerName: null,
      },
    },
  });

  useEffect(() => {
    if (trainer?.id) {
      // Redirect to the normal trainer detail page with the actual ID (no slug needed)
      navigate({
        path: UniversalRoutes.TRAINERS.DETAIL,
        params: { trainerId: trainer.id },
      });
    }
  }, [trainer, navigate]);

  if (isLoading) {
    return <FancyLoader />;
  }

  if (error) {
    return (
      <div>
        <h2>Trainer not found</h2>
        <p>The invite code "{inviteCode}" is not valid or has expired.</p>
      </div>
    );
  }

  // Show loader while redirecting
  return <FancyLoader />;
};
